<script>
  import { style, present, blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link } from "svelte-routing";

  export let block;
</script>

<!-- -------- START HEADER 7 w/ card over right bg image ------- -->
<section style="{style(block)}">
  <div class="page-header" style="min-height: 80vh !important;">
    <div class="position-absolute fixed-top ms-auto w-50 h-100 z-index-0 d-none d-sm-none d-md-block"
         style="background-image: url({image(block, 'background', [800, 800])}); background-size:cover;"></div>
    <div class="container">
      <div class="row">
        <div class="col-lg-7 d-flex justify-content-center flex-column">
          <div class="card card-body blur d-flex justify-content-center shadow-lg p-5"
               style="min-height: 500px;">
            <h2 class="">{text(block, 'heading(gradiant)')}</h2>
            <h3 class="mb-4" style="color: #112d5d">{text(block, 'subheadline')}</h3>
            <p class="lead pe-5 me-5">{@html richtext(block, 'body')}</p>
            <div class="buttons">
              {#if present(block, 'button')}
              <a href="{url(block, 'button')}" type="button" class="btn mt-4">
                {text(block, 'button')}
              </a>
              {/if}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- -------- END HEADER 8 w/ card over right bg image ------- -->
